import type { DashboardSharingStatus } from './dashboard.types';

export const DASHBOARD_SHARING_OPTIONS = [
  {
    value: 'private',
    iconName: 'lock',
    labelKey: 'app.dashboard.shareModal.privateLabel',
    descriptionKey: 'app.dashboard.shareModal.privateDescription',
  },
  {
    value: 'global',
    iconName: 'public',
    labelKey: 'app.dashboard.shareModal.globalLabel',
    descriptionKey: 'app.dashboard.shareModal.globalDescription',
  },
] as const satisfies ReadonlyArray<{
  value: DashboardSharingStatus;
  iconName: string;
  labelKey: string;
  descriptionKey: string;
}>;

export function getDashboardSharingOption(status: DashboardSharingStatus) {
  return (
    DASHBOARD_SHARING_OPTIONS.find((option) => option.value === status) ??
    DASHBOARD_SHARING_OPTIONS[0]
  );
}
